export default __webpack_public_path__ + "static/media/Broncos.8ce58526.png";